import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../Services/Auth/auth.service';
import { UserProfileData } from 'src/app/interfaces/user-profile-data';

@Component({
    selector: 'app-engage-nav-bar',
    templateUrl: './engage-nav-bar.component.html',
    styleUrls: ['./engage-nav-bar.component.scss'],
    standalone: false
})
export class EngageNavBarComponent {
  userProfile: UserProfileData | null = null;
  @Output() sectionChange = new EventEmitter<string>();

  constructor(private authService: AuthService, private router: Router) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    // Subscribe to the userProfile$ observable to get the user profile
    this.authService.userProfile$.subscribe((profile) => {
      this.userProfile = profile;
    });
  }
  /* istanbul ignore next */
  navigateToLanding(): void {
    this.router.navigateByUrl('/landing');
  }
  /* istanbul ignore next */
  handleKeyDown(event: KeyboardEvent, menuName: string) {
    // For example, toggle submenu on 'Enter' key press
    if (event.key === 'Enter') {
      // this.toggleSubMenu(menuName as keyof SubMenus);
    }
  }
  /* istanbul ignore next */
  changeSection(section: string) {
    this.sectionChange.emit(section);
  }

  /* istanbul ignore next */
  logout() {
    console.log('Logging out...');
    this.authService.logout();
  }
  /* istanbul ignore next */
  shouldStackName(): boolean {
    const nameLengthThreshold = 15;
    return (
      (this.userProfile?.given_name?.length ?? 0) +
        (this.userProfile?.family_name?.length ?? 0) >
      nameLengthThreshold
    );
  }
}
